import {
    Action,
    DEFAULT_OPEN_LOCATION_ACTION,
    getDefaultButton,
} from '../../model/components/ActionButton';
import { TilePuzzlePostData } from '../../model/types/TilePuzzlePostData';
import { ActionButtonInput } from './ActionButtonInput';
import { FileInput, FileInputProps } from './FileInput';
import { MediaInput } from './MediaInput';

import styles from './TilePuzzlePostInput.module.scss';

export interface TilePuzzlePostInputProps {
    value: TilePuzzlePostData;
    onChange?: (value: TilePuzzlePostData) => void;
}

const BUTTON_ACTION_OPTIONS: Array<{
    value: Action['$type'] | 'none';
    label: string;
}> = [
    {
        value: 'none',
        label: 'No Button',
    },
    {
        value: 'OpenLocation',
        label: 'Open Location Button',
    },
];
export const TilePuzzlePostInput = ({
    value,
    onChange,
}: TilePuzzlePostInputProps) => {
    const onButtonOptionChange = (option: string) => {
        switch (option as (typeof BUTTON_ACTION_OPTIONS)[number]['value']) {
            case 'OpenLocation':
                onChange?.({
                    ...value,
                    winViewData: {
                        ...value.winViewData,
                        button: getDefaultButton(DEFAULT_OPEN_LOCATION_ACTION),
                    },
                });
                break;
            case 'none':
                onChange?.({
                    ...value,
                    winViewData: {
                        ...value.winViewData,
                        button: undefined,
                    },
                });
                break;
        }
    };
    const onGameMediaUrlChange: FileInputProps['onChange'] = (file) => {
        onChange?.({
            ...value,
            gameTextureUrl: file?.url,
        });
    };
    return (
        <div className={styles.container}>
            <fieldset>
                <legend>Game Media</legend>
                <FileInput
                    allowedFileTypes="image"
                    value={
                        value.gameTextureUrl
                            ? {
                                  url: value.gameTextureUrl,
                                  fileType: 'image',
                              }
                            : undefined
                    }
                    onChange={onGameMediaUrlChange}
                />
            </fieldset>

            <fieldset>
                <legend>Win Media</legend>
                <MediaInput
                    value={value.winViewData?.media}
                    onChange={(media) =>
                        onChange?.({
                            ...value,
                            winViewData: {
                                ...value.winViewData,
                                media,
                            },
                        })
                    }
                />
                <br />
                <fieldset>
                    <legend>Button</legend>
                    <select
                        value={
                            value.winViewData?.button
                                ? value.winViewData.button.action.$type
                                : 'none'
                        }
                        onChange={(e) => onButtonOptionChange(e.target.value)}
                    >
                        {BUTTON_ACTION_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    {value.winViewData?.button && (
                        <ActionButtonInput
                            value={value.winViewData.button}
                            onChange={(button) =>
                                onChange?.({
                                    ...value,
                                    winViewData: {
                                        ...value.winViewData,
                                        button,
                                    },
                                })
                            }
                        />
                    )}
                </fieldset>
            </fieldset>
        </div>
    );
};
